import cn from "classnames"
import { useLayoutEffect, useRef } from "react"

import { Table } from "@/atoms"
import { useTooltip } from "@/hooks/useTooltip"
import { setWidthVariable } from "@/organisms/ResizableTable"

import styles from "./ExpandedRowTable.module.scss"

import type { GetRef } from "@/atoms"
import type { TableProps } from "./ExpandedRowTable.types"

export const ExpandedRowTable = <T extends object>(
  props: TableProps<T> & { initialMinHeight?: boolean; resizable?: boolean }
) => {
  const { initialMinHeight, resizable, ...rest } = props
  const ref = useRef<GetRef<typeof Table>>(null)

  useTooltip(rest.dataSource)

  useLayoutEffect(() => {
    if (!resizable) return

    const colElement = ref.current?.nativeElement.querySelectorAll("col")

    setWidthVariable(colElement, (node, { index, widthVariable }) => {
      if (node.style.width.includes("var")) return false

      const width = `var(${widthVariable}, ${node.style.width || "initial"})`

      node.style.width =
        index === 0
          ? `calc(${width} - var(--offset-left-selection, 12px))`
          : width
    })
  }, [resizable])

  return (
    <Table
      ref={ref}
      className={cn(
        styles.table,
        initialMinHeight && styles.initialMinimumHeight,
        !!rest.footer && styles.withFooter,
        resizable && styles.resizable
      )}
      pagination={false}
      showHeader={false}
      {...rest}
    />
  )
}
